import { Vue } from 'vue-property-decorator';
import loader from '../../../utils/loader';
import store from '../../../store';
import voucherService from '../../../services/voucher';
import VoucherTransformer, { voucherMixin } from '../../../transformers/voucher';
import tableMixin from '../../../Mixins/table';
import formMixin from '../../../Mixins/form';
import arrUtil from '../../../utils/arrayUtil';
import Form from '../../../form/form';
import voucherTransformer from '../../../transformers/voucher';
import { debounce } from 'lodash';

export default Vue.extend({
  store,
  mixins: [voucherMixin, tableMixin, formMixin],
  data: () => ({
    loadingVoucher: false,
    formEditNote: new Form({
      data() {
        return {
          id: '',
          note: '',
          valid: false,
        };
      },
    }),
    formSendVoucher: new Form({
      data() {
        return {
          id: '',
          username: '',
          email: null,
          support_pin: null,
          resend: 'true',
          valid: false,
        };
      },
      transformToPayload: voucherTransformer.convertUsernameToEmailOrSupportPin,
      transformToForm: voucherTransformer.convertEmailOrSupportPinToUsername,
    }),
    formVoucher: new Form({
      data() {
        return {
          id: '',
        };
      },
    }),
    panelVoucher: [true],
    search: '',
    dialogEditNote: false,
    dialogSendVoucher: false,
    selectedVoucher: null,
    dictionary: {
      attributes: {
        note: 'Note',
        username: 'E-mail Address or Support Pin',
      },
      custom: {},
    },
    vouchers: [],
    totalVouchers: 0,
    vouchersPagination: {
      sortBy: ['created_at'],
      sortDesc: [true],
    },
    voucherHeaders: [
      {
        text: 'Code',
        align: 'center',
        value: 'code',
        sortable: false,
        // width: '80%'
      },
      { text: 'Amount', align: 'center', value: 'amount', sortable: false },
      {
        text: 'Status',
        align: 'center',
        value: 'status',
        sortable: false,
      },
      {
        text: 'Type',
        align: 'center',
        value: 'type',
        sortable: false,
      },
      {
        text: 'By',
        align: 'center',
        value: 'by',
        sortable: false,
        // width: '2%'
      },
      {
        text: 'Use By',
        align: 'center',
        value: 'visibility',
        sortable: false,
        // width: '2%'
      },
      {
        text: 'Redeemed At',
        align: 'center',
        value: 'updated_at',
        sortable: true,
      },
      {
        text: 'Expire Date',
        align: 'center',
        value: 'expiration',
        sortable: true,
      },
      {
        text: 'Voucher Order',
        align: 'center',
        value: 'visibility',
        sortable: false,
      },
      {
        text: 'Send To',
        align: 'center',
        value: 'visibility',
        sortable: false,
      },
      { text: 'Note', align: 'center', value: 'visibility', sortable: false },
      {
        text: 'Transfer Receipt',
        align: 'center',
        value: 'visibility',
        sortable: false,
      },
      {
        text: 'Created At',
        align: 'center',
        value: 'created_at',
        sortable: true,
      },
      {
        text: 'Action',
        align: 'center',
        value: 'id',
        sortable: false,
      },
    ],
  }),
  computed: {},
  watch: {
    vouchersPagination: {
      handler() {
        this.getVoucherList().then((data) => {
          this.vouchers = data.items;
          this.totalVouchers = data.total;
        });
      },
      deep: true,
    },
    search() {
      this.getVoucherList().then((data) => {
        this.vouchers = data.items;
        this.totalVouchers = data.total;
      });
    },
  },
  created() {},
  mounted() {},
  methods: {
    getVoucherList() {
      this.loadingVoucher = true;
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.vouchersPagination;
        let query = {};
        if (itemsPerPage !== -1) {
          query.per_page = itemsPerPage;
          query.page = page;
        } else if (itemsPerPage == -1 && this.totalVouchers) {
          query.per_page = this.totalVouchers;
          query.page = page;
        }
        if (sortBy.length) {
          query.order = sortBy[0];
          query.sort = sortDesc[0] ? 'desc' : 'asc';
        } else {
          (query.order = 'created_at'), (query.sort = 'desc');
        }

        if (this.search) query.q = this.search;

        voucherService
          .all(query)
          .then((data) => {
            let items = data.data;
            const meta = data.meta;
            const total = meta.pagination.total;
            this.loadingVoucher = false;
            resolve({
              items,
              total,
            });
          })
          .catch((err) => {
            this.loadingVoucher = false;
            reject(err);
          });
      });
    },
    viewReceipt(one) {
      if (one.transfer_receipt) {
        window.open(one.transfer_receipt, '_blank');
      }
    },
    deleteVoucher(one) {
      this.$root
        .$confirm('Delete', `Are you sure for deleting <b>${one.code}</b> ?`, {
          color: 'error',
          submitText: 'delete',
        })
        .then((confirm) => {
          if (confirm) {
            this.formVoucher.id = one.id;
            voucherService
              .deletes(this.formVoucher)
              .then(() => {
                this.vouchers = window._.reject(this.vouchers, { id: one.id });
                this.totalVouchers -= 1;
                this.$notify({
                  title: 'Delete',
                  text: `Delete ${one.code} success !!`,
                  type: 'success',
                });
              })
              .catch(() => {});
          }
        });
    },
    submitFormSendVoucher() {
      this.$validator.validateAll('formSendVoucher').then((result) => {
        if (result) {
          this.$root
            .$confirm('Voucher', 'Are you confirm to submit?', {
              color: 'primary',
            })
            .then((confirm) => {
              if (confirm) {
                voucherService.patch(this.formSendVoucher).then((data) => {
                  // console.log(data);
                  this.vouchers = arrUtil.searchByIdentityAndChangeAnyValue(this.vouchers, { id: data.id }, data);
                  this.$notify({
                    title: 'Success',
                    text: 'Voucher are send success !!',
                    type: 'success',
                  });
                  this.dialogSendVoucher = false;
                });
              }
            });
        }
      });
    },
    submitResendVoucher() {
      this.$root
        .$confirm('Voucher', 'Are you confirm to submit?', {
          color: 'primary',
        })
        .then((confirm) => {
          if (confirm) {
            const params = {
              id: this.formSendVoucher.id,
              payload: {
                resend: 'true',
              },
            };
            voucherService.patch(params).then(() => {
              this.$notify({
                title: 'Success',
                text: 'Voucher are resend !!',
                type: 'success',
              });
              this.dialogSendVoucher = false;
            });
          }
        });
    },
    setSelectdVoucher(one) {
      this.selectedVoucher = window._.clone(one, true);
      this.selectedVoucher = VoucherTransformer.convertEmailOrSupportPinToUsername(this.selectedVoucher);
      this.formSendVoucher.id = one.id;
      this.formSendVoucher.email = one.email;
      this.formSendVoucher.support_pin = one.support_pin;
      this.formSendVoucher.username = this.selectedVoucher.username;

      this.formEditNote.id = one.id;
      this.formEditNote.note = one.note;
    },
    submitFormNote() {
      this.$validator.validateAll('formEditNote').then((result) => {
        if (result) {
          this.$root
            .$confirm('Voucher', 'Are you confirm to submit?', {
              color: 'primary',
            })
            .then((confirm) => {
              if (confirm) {
                voucherService
                  .patch(this.formEditNote)
                  .then((data) => {
                    this.vouchers = arrUtil.searchByIdentityAndChangeAnyValue(
                      this.vouchers,
                      { id: data.id },
                      { note: data.note }
                    );
                    this.$notify({
                      title: 'Success',
                      text: "Voucher'note are submited success !!",
                      type: 'success',
                    });
                    this.dialogEditNote = false;
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            });
        }
      });
    },
    refresh() {
      this.getVoucherList().then((data) => {
        this.vouchers = data.items;
        this.totalVouchers = data.total;
      });
    },
    debounceInput: debounce(function (e) {
      this.search = e;
    }, 500),
  },
  components: {
    CreateVoucher: loader.component('CreateVoucher'),
  },
});
